import React from "react";

export function GitIcon({ className }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M22.0402 9.91723L22.011 9.84261L19.1842 2.4653C19.1267 2.32071 19.0248 2.19805 18.8933 2.11493C18.7617 2.03321 18.6081 1.99386 18.4534 2.00217C18.2987 2.01049 18.1503 2.06607 18.0282 2.16143C17.9074 2.25951 17.8198 2.39243 17.7773 2.54208L15.8686 8.38164H8.13984L6.23117 2.54208C6.18978 2.39161 6.10199 2.25803 5.98029 2.16034C5.85817 2.06499 5.70974 2.00941 5.55504 2.00109C5.40033 1.99278 5.2468 2.03213 5.11517 2.11384C4.98391 2.1973 4.88217 2.31985 4.82427 2.46422L1.99208 9.83828L1.96397 9.9129C1.55704 10.9761 1.50681 12.1429 1.82085 13.2371C2.1349 14.3314 2.79619 15.2939 3.70502 15.9796L3.71475 15.9871L3.74071 16.0055L8.04684 19.2302L10.1772 20.8426L11.4749 21.8224C11.6267 21.9376 11.812 22 12.0026 22C12.1932 22 12.3785 21.9376 12.5303 21.8224L13.828 20.8426L15.9584 19.2302L20.2905 15.986L20.3013 15.9774C21.2081 15.2916 21.8678 14.3301 22.1814 13.2373C22.4949 12.1445 22.4454 10.9795 22.0402 9.91723Z"
        fill="currentColor"
      />
    </svg>
  );
}
